import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface PaymentTestChipProps {
  test: boolean;
}

/**
 * Значение столбца «Тестовый» в списках платежей (поле `test` из GET /admin/payments): чип Да/Нет,
 * в стиле чипа статуса в соседнем столбце. «Да» — оранжевый, чтобы тестовый платёж бросался в глаза.
 */
export const PaymentTestChip: React.FC<PaymentTestChipProps> = ({ test }) => {
  const { t } = useTranslation();
  return (
    <Chip
      label={t(test ? 'admin:common.yes' : 'admin:common.no')}
      color={test ? 'warning' : 'default'}
      size="small"
      variant="outlined"
    />
  );
};

export default PaymentTestChip;
